/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import '@fortawesome/fontawesome-pro/css/all';
import '@fortawesome/fontawesome-pro/css/v4-shims'

import { masonrySetup } from 'masonry_init';

import '../scripts/session_timeout';

document.addEventListener("DOMContentLoaded", function () {
  masonrySetup();
});
document.addEventListener("reinitMasonary", function () {
  masonrySetup();
});

import ProgrammeHelper from "services/programme_helper";

document.addEventListener("DOMContentLoaded", function () {
  const currentProgrammeIdentifier = document.getElementsByTagName("body")[0].dataset.currentProgrammeIdentifier;
  const defaultProgrammeIdentifier = document.getElementsByTagName("body")[0].dataset.defaultProgrammeIdentifier;
  const currentProgrammeAssessmentType = document.getElementsByTagName("body")[0].dataset.currentProgrammeAssessmentType;
  window.programmeHelper = new ProgrammeHelper(currentProgrammeIdentifier, defaultProgrammeIdentifier, currentProgrammeAssessmentType);
});

var componentRequireContext = require.context("pages", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
